import React from "react";
import MiddleHeader from "./MiddleHeader.tsx"

const Header = () => {

  return (
    <>
      <MiddleHeader />
    </>
  )
}

export default Header
